import { Alert, SelectChangeEvent } from "@mui/material";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { HolzfinderTaxSelect } from "components/inputs/HolzfinderTaxSelect";
import { selectSeller, setTaxationKindId } from "features/seller/sellerSlice";
import { useState } from "react";
import SellerGrid from "./SellerGrid";

export default function SellerOptions(props: any) {
  const { error, setChangesSaved } = props;

  const sellerData = useAppSelector(selectSeller);
  const [taxationKind, setTaxType] = useState(
    sellerData?.taxation_kind_id || ""
  );
  const dispatch = useAppDispatch();

  return (
    <SellerGrid>
      {error && <Alert severity="error">{error}</Alert>}
      <HolzfinderTaxSelect
        value={taxationKind}
        onChange={(event: SelectChangeEvent<unknown>) => {
          setTaxType(event.target.value as string);
          setChangesSaved(false); // Reset changes saved state
          dispatch(setTaxationKindId(event.target.value));
        }}
      />
    </SellerGrid>
  );
}
